// extracted by mini-css-extract-plugin
module.exports = {"tooltipBase":"styles-module_tooltipBase__z4JtBBsGtqjRYYI51KaM"};